module.exports = __webpack_public_path__ + "static/media/zoom-logo.495a70bf.svg";